document.addEventListener('DOMContentLoaded', function() {

    const searchInput = document.getElementById('resources-search');

    if(searchInput) {
        const searchResults = document.getElementById('resources-search-results');
        let controller = null;

        let isSearching = false;

        const searchCallback = function(e) {
            if (controller) {
                controller.abort();
            }

            controller = new AbortController();
            const signal = controller.signal;

            const searchString = e.target.value;
            const currentType = 'all';

            const formData = new FormData();
            formData.append("action", "get_resources_by_title");
            formData.append("title_like", searchString);
            formData.append("post_type", currentType);

            if(searchString.trim().length > 2) {

                if (!isSearching) {
                    searchResults.innerHTML = `<span>Searching...</span>`;
                    isSearching = true;
                }

                fetch(themeVars.ajaxUrl, {
                    method: "POST",
                    body: formData,
                    headers: {
                        Accept: "application/json",
                    },
                    signal: signal,
                })
                .then(response => {
                    if (response.ok) {
                        return response.json();
                    } else {
                        throw new Error('Failed to fetch data');
                    }
                })
                .then(data => {
                    searchResults.innerHTML = '';
                    isSearching = false;

                    if(data && data.length) {
                        data.forEach((result) => {
                            searchResults.innerHTML += `<a href="${result.link}">${result.title}</a>`;
                        })
                    }
                    else {
                        searchResults.innerHTML = `<span>Sorry, nothing found at your request</span>`;
                    }
                })
                .catch(error => {
                    console.error('Error: ', error);
                });
            }
            else {
                searchResults.innerHTML = '';
            }
        }

        searchInput.addEventListener('keyup', searchCallback);

        searchInput.addEventListener('search', function() { // click on 'clear' button
            searchResults.innerHTML = '';
        })
    }
});



// WEBPACK FOOTER //
// ./scripts/modules/resources-search.js